import _ from 'lodash';
import server from 'common/utils/server';
import { getSearchFilter } from 'common/utils/locationUtils';
import { DateTime, usaDateFormat } from 'common/utils/date';

export const draftReportState = (
  state = {
    reviewDraftsById: {},
    reviewDraftsByTablePage: {},
    totalReviewDraftTablePages: null,
    totalReviewDraftCount: null,
    lastFetchQueryParams: {},
    reviewDraftsSortedBy: null,
    reviewDraftsSortDirection: null,
    tableViewPage: 1,
  },
  action
) => {
  switch (action.type) {
    case 'qa_review_drafts/SET_TABLE_VIEW_PAGE': {
      const { tableViewPage } = action;
      return { ...state, tableViewPage };
    }
    case 'qa_review_drafts/RECEIVED_REVIEW_DRAFTS': {
      const { reviewDrafts, page, totalReviewDraftTablePages, queryParams } = action.value;
      const reviewDraftsById = { ...state.reviewDraftsById };
      reviewDrafts.forEach(reviewDraft => {
        reviewDraftsById[reviewDraft.id] = reviewDraft;
      });

      let reviewDraftsByTablePage = { ...state.reviewDraftsByTablePage };
      // if any of the query params have changed (besides page),
      // clear out reviewDraftsByTablePage
      const oldParams = { ...state.lastFetchQueryParams };
      delete oldParams.page;
      const newParams = { ...queryParams };
      delete newParams.page;
      if (!_.isEqual(oldParams, newParams)) {
        reviewDraftsByTablePage = {};
      }
      reviewDraftsByTablePage[page] = reviewDrafts;
      return {
        ...state,
        reviewDraftsById,
        reviewDraftsByTablePage,
        totalReviewDraftTablePages,
        lastFetchQueryParams: queryParams,
      };
    }
    case 'qa_review_drafts/CLICKED_REVIEW_DRAFT_TABLE_HEADER': {
      if (!state.totalReviewDraftTablePages) {
        return state;
      }
      const { sortBy } = action;
      const { reviewDraftsSortedBy } = state;
      let { reviewDraftsSortDirection } = state;
      if (sortBy === reviewDraftsSortedBy) {
        reviewDraftsSortDirection =
          reviewDraftsSortDirection === 'ascending' ? 'descending' : 'ascending';
      } else {
        const columnsWithDescendingDefaultSort = ['interaction_id'];
        reviewDraftsSortDirection =
          columnsWithDescendingDefaultSort.includes(sortBy) ? 'descending' : 'ascending';
      }
      return {
        ...state,
        reviewDraftsSortedBy: sortBy,
        reviewDraftsSortDirection,
      };
    }
    default: {
      return state;
    }
  }
};

export const loadReviewDrafts = (history, customProperties) => async (dispatch, getState) => {
  const { draftReportState } = getState();
  const {
    startDate,
    endDate,
    teamIds,
    groupIds,
    reportingGroupIds,
    employeeIds,
    reviewerIds,
    qaFormIds,
    languages,
    channelEnumIds,
    propertyIds,
    autofailed,
  } = getSearchFilter(history);
  const { reviewDraftsSortedBy, reviewDraftsSortDirection, tableViewPage } = draftReportState;
  const queryParams = {
    started_from: startDate,
    started_to: endDate,
    drafted: true,
    by_reviewer_id: reviewerIds,
    by_employee_id: employeeIds,
    for_teams: teamIds,
    for_groups: groupIds,
    for_reporting_groups: reportingGroupIds,
    by_qa_form_id: qaFormIds,
    by_language: languages,
    by_channel_enum_id: channelEnumIds,
    by_property_id: propertyIds,
    page: tableViewPage,
    autofailed,
    custom_properties: customProperties,
  };
  if (reviewDraftsSortedBy) {
    queryParams.order_by = reviewDraftsSortedBy;
    queryParams.order_direction = reviewDraftsSortDirection === 'descending' ? 'desc' : 'asc';
  }
  const { qa_reviews, /* next_page, total_count, */ total_pages } = await server.get(
    '/api/v1/qa_reviews',
    queryParams
  );
  dispatch({
    type: 'qa_review_drafts/RECEIVED_REVIEW_DRAFTS',
    value: {
      reviewDrafts: qa_reviews
        .map(review => {
          if (!review.employee || !review.reviewer) {
            return null;
          }

          return {
            id: review.id,
            scorecardName: review.qa_form_name,
            annotationsCount: review.qa_annotations_count,
            employeeName: `${review.employee.first_name} ${review.employee.last_name}`,
            reviewerName: `${review.reviewer.first_name} ${review.reviewer.last_name}`,
            interactionId: review.interaction_id,
            startedAt: DateTime.fromISO(review.started_at).toFormat(usaDateFormat),
            score: `${review.percentage_score}%`,
            employeeImage: review.employee.image,
          };
        })
        .filter(Boolean),
      page: tableViewPage,
      totalReviewDraftTablePages: total_pages,
      queryParams,
    },
  });
};

export const clickedReviewDraftTableHeader =
  ({ history, sortBy, customProperties }) =>
  dispatch => {
    dispatch({
      type: 'qa_review_drafts/CLICKED_REVIEW_DRAFT_TABLE_HEADER',
      sortBy,
    });
    dispatch(loadReviewDrafts(history, customProperties));
  };
